const nbTranslations = {
    ok: 'Ok',
    insurance: {
        insuranceHeader: 'Mine forsikringer',
        insuranceNumberHeader: 'Viser {} av {}',
        newInsuranceHeader: 'Trenger du ny forsikring?',
        newInsuranceDescription: 'Hos oss får du forsikringer tilpasset deg – og mulighet til å samle alt på ett sted',
        oldInsuranceDescription: 'Hos oss får du gode forsikringer tilpasset ditt behov',
        showMore: 'Se mine forsikringer',
        error: 'Noe gikk galt ved henting av dine forsikringer.',
        tryAgain: 'Prøv igjen',
        year: '/år',
        show: 'Viser',
        of: 'av',
        buyInsuranceButton: 'Kjøp forsikring',
        buyInsuranceTitle: 'Har du forsikringene du trenger?',
        buyInsuranceSubtext: 'Vi har gode forsikringer for livets små og store hendelser. Du kan enkelt samle flere hos oss – så får du bedre oversikt og færre bekymringer.',
        seePriceAndBuyButton: 'Sjekk pris og kjøp',
        fremtindText: 'Våre forsikringer leveres av Fremtind',
        insurance: 'Forsikring',
    },
    holdings: {
        header: 'Min sparing',
        totalAmount: 'Totalt {}',
        savingHeader: 'Spare mer?',
        savingDescription: 'Du sparer i dag {} i måneden.',
        showMore: 'Se dine spareprodukter',
        error: 'Noe gikk galt ved henting av dine spareprodukter.',
        tryAgain: 'Prøv igjen',
    },
    totalSavings: {
        header: 'Sparing',
        totalFundsTitle: 'Total fondssparing',
        startSavingTitle: 'Start sparing i fond',
        startSavingDescription: 'Start med et lite beløp og bygg trygghet over tid.',
        error: 'Vi får ikke vist spareoversikten din. Prøv igjen senere',
        tryAgain: 'Prøv på nytt',
    },
    loans: {
        header: 'Mine lån',
        numberHeader: 'Viser {} av {}',
        infoHeader: 'Store planer?',
        infoDescription: 'Se hvilke lån vi tilbyr her',
        error: 'Noe gikk galt ved henting av dine lån.',
        tryAgain: 'Prøv igjen',
        showMore: 'Se dine lån',
        ekbLoans: {
            CREDIT_LOAN: 'Forbrukslån',
            EMPLOYEE: 'Forbrukslån',
            ATV: 'ATV-lån',
            CAR: 'Billån',
            CAR_NO_INSURANCE: 'Billån',
            CAR_ZERO_EMISSION: 'Elbillån',
            BOAT: 'Båtlån',
            CAMPING_CAR: 'Bobillån',
            CARAVAN: 'Campingvognlån',
            MC: 'MC-lån',
            SNOWMOBILE: 'Snøscooterlån',
        },
        moneyOnTheWay: 'Pengene er på vei',
        nominalInterest: 'Nominell rente {}%',
        studentLoan: 'Studielån',
        consentStatus: 'Ditt samtykke utløper snart',
    },
    loanOverview: {
        title: 'Andre lån',
        nominalInterest: 'Nominell rente {}%',
        studentLoan: 'Studielån',
        consentStatus: 'Ditt samtykke utløper snart',
        moneyOnTheWay: 'Pengene er på vei',
    },
    taskManager: {
        title: 'Oppgaver',
        documentsForSigning: 'Oppgaver til gjennomgang',
        emptyState: 'Her var det stille og rolig',
        noTasks: 'Du har ingen oppgaver som venter',
        errors: {
            documents: 'Noe gikk galt ved henting av dokumenter til signering',
            loanApplications: 'Noe gikk galt ved henting av lånesøknader',
            general: 'Noe gikk galt ved henting av oppgaver',
        },
        loanApplications: {
            type: {
                HOUSE_LOAN_INCREASE: 'Søknad om økt boliglån',
                PROOF_OF_FINANCING: 'Søknad om finansieringsbevis',
                NEW_LOAN: 'Søknad om nytt boliglån på eksisterende bolig',
                MOVING: 'Søknad om flytting av boliglån',
                HOUSE_LOAN: 'Søknad om boliglån',
                UNKNOWN: '',
            },
            status: {
                ACTIVE: 'Søknad påbegynt',
                WAITING_FOR_CO_BORROWER: 'Venter på medlåntaker',
                APPLICATION_BEING_PROCESSED: 'Behandles',
                APPROVED: 'Nytt lånetilbud',
                BEING_PREPARED_FOR_PAYMENT: 'Klargjøres for utbetaling',
                PAID_OUT: 'Utbetalt',
                REFUSED: 'Avslått',
                CLOSED: 'Avsluttet',
                EXPIRED: 'Utløpt',
                INFORMATION_BEING_PROCESSED: 'Opplysningene blir behandlet',
                WAITING_FOR_YOUR_APPROVAL: 'Venter på ditt samtykke',
                UNKNOWN: '',
            },
            needsAction: 'Krever handling',
        },
    },
    landingPage: {
        emptyState: 'Enten er du ikke kunde hos oss, eller så kan det være andre årsaker til at du har landet her. Usikker? \n Ta kontakt med oss!',
    },
    errorMessage: 'Vi beklager, det har skjedd en feil, så du kan ikke sjekke alle lånene dine.',
};
export default nbTranslations;
//# sourceMappingURL=data:application/json;base64,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